<template>
	<div id="add-policy" v-if="editedItem">
		<div class="tab-header">
			<v-row>
				<v-col>
					<label class="tab-title">{{ $t("ADD_NEW_PAYMENT_POLICY") }}</label>
				</v-col>
			</v-row>
		</div>
		<div class="tab-content">
			<v-row>
				<v-col sm="6">
					<label class="label-input">{{ $t("DEPOSIT_BEFORE_CHECKIN") }} *</label>
					<v-row>
						<v-col sm="9">
							<b-form-select
							:options="depositOptions" 
							v-model="depositDay"
							@change="$event => changeDepositDay($event)"
						/>
						</v-col>
						<v-col sm="3">
							<input class="input" v-if="showInputTextCutOf === true"
								type="number"
								maxlength="3"
								min="0"
								v-model="editedItem.cutOfDate"
								:error.sync="error.cutOfDate.error"
								:errorMessage="error.cutOfDate.message"
							/>
						</v-col>
					</v-row>
				</v-col>
			</v-row>

			<v-row>
				<v-col sm="6">
					<label class="label-input">{{ $t("DEPOSIT_LEVEL_APPLIES") }} *</label>
					<select-unit
						:items="select.unit"
						:regex="REGEX_NUMBER"
						:isMoney="true"
						:maxValue="editedItem.depositType == 1 ? 100 : null"
						:notSmallThan="-1"
						:model.sync="editedItem.amount"
						:id.sync="editedItem.depositType"
						:error.sync="forfeitError"
					/>
				</v-col>
			</v-row>
			<v-row>
				<v-col sm="6">
					<label class="label-input">{{ $t("PAYMENT_BEFORE_DAY_CHECKIN_DATE") }} *</label>
					<v-row>
						<v-col sm="9">
							<b-form-select
							:options="paymentOptions" 
							v-model="paymentDay"
							@change="$event => changePaymentDay($event)"
						/>
						</v-col>
						<v-col sm="3">
							<input v-if="showInputText === true" class="input"
								maxlength="3"
								type="number"
								v-model="editedItem.paymentDay"
								:error.sync="error.paymentDay.error"
								:errorMessage="error.paymentDay.message"
							/>
						</v-col>
					</v-row>
				</v-col>
			</v-row>

			<v-row>
				<v-col sm="12" class="pb-0">
					<label class="label-input">{{ $t("TIME_APPLICATION") }}</label>
					<v-radio-group row v-model="editedItem.type" class="mt-2 ml-2">
						<v-radio color="indigo darken-3" :label="$t('ALWAYS')" :value="0"></v-radio>
						<v-radio color="indigo darken-3" :label="$t('IN_PERIOD')" :value="1"></v-radio>
					</v-radio-group>
				</v-col>
			</v-row>

			<v-row class="date-picker">
				<v-col sm="3" class="py-0">
					<label class="label-input mb-0">{{ $t("FROM_DATE") }}</label>
					<date-picker
						:model.sync="editedItem.startDate"
						:error.sync="error.startDate.error"
						:disabled="!editedItem.type"
					/>
				</v-col>
				<v-col sm="3" class="py-0">
					<label class="label-input mb-0">{{ $t("TO_DATE") }}</label>
					<date-picker
						:model.sync="editedItem.endDate"
						:error.sync="error.endDate.error"
						:min="editedItem.startDate"
						:disabled="!editedItem.type"
					/>
				</v-col>
			</v-row>
			<v-row>
				<v-col sm="6" class="py-0">
					<div class="btn-bottom mt-5">
						<button class="btn btn-back mr-5" @click="back">{{ $t("BACK") }}</button>
						<button class="btn btn-save" @click="save">{{ $t("SAVE") }}</button>
					</div>
				</v-col>
			</v-row>
		</div>
	</div>
</template>
<style>
	.input {
		width: 100%;
		height: 40px;
		padding-left: 12px;
	}
</style>
<script>
import DatePicker from "@/components/Utils/DatePicker.vue";
import Input from "@/components/Utils/Input.vue";
import SelectUnit from "@/components/Utils/SelectUnit.vue";
import Select from "@/components/Utils/Select.vue";
import { REGEX_NUMBER } from "@/_helpers/constant.js";
import { AP_ERROR } from "@/_helpers/config.js";
import {
	_validateFormI18n,
	_alert,
	_resetErrorState
} from "@/_helpers/function.js";
import { service } from "@/_services/HotelSetting/payment-policy.service.js";

export default {
	components: {
		"date-picker": DatePicker,
		"input-text": Input,
		"select-unit": SelectUnit,
		"select-text": Select
	},
	data() {
		return {
			editedItem: null,
			select: {
				unit: [{ id: 0, value: "VND" }, { id: 1, value: "%" }]
			},
			error: AP_ERROR,
			forfeitError: {
				value: null,
				unit: null
			},
			paymentOptions: [
				{ value: 0, text: this.$t("PAYMENT_BEFORE_DAY_CHECKIN_DATE") }, //Thanh toán vào ngày nhận phòng
				{ value: -1, text: this.$t("PAYMENT_BEFORE_CHECKOUT_DATE") }, // thanh toan vao ngay tra phong
				{ value: 3, text: this.$t("PREPAYMENT_BEFORE_CHECKIN_DATE") } // thanh toan trc ngay nhan phong
			],
			depositOptions: [
				{ value: -1, text: this.$t("DEPOSIT_ON_THE_DAY_OF_BOOKING") },
				{ value: 0, text: this.$t("DEPOSIT_ON_CHECKIN_DATE") },
				{ value: 3, text: this.$t("DEPOSIT_BEFORE_CHECKIN_DATE") }
			],
			paymentDay: -1,
			depositDay: -1,
			showInputText: false,
			showInputTextCutOf: false
		};
	},
	async created() {
		let id = parseFloat(this.$route.params.id);
		if (id) {
			let params = {
				limit: 0,
				offset: 0
			};
			await service.get(params).then(res => {
				params = {
					limit: res.total,
					offset: 0
				};
			});
			await service.get(params).then(res => {
				this.editedItem = Object.assign({}, res.data.find(x => x.id == id));
				if (this.editedItem.paymentDay > 0 ) {
					this.paymentDay = 3;
					this.showInputText = true;
				} else {
					this.paymentDay = this.editedItem.paymentDay;
					this.showInputText = false;
				}
				if (this.editedItem.cutOfDate > 0 ) {
					this.depositDay = 3;
					this.showInputTextCutOf = true;
				} else {
					this.depositDay = this.editedItem.cutOfDate < 0 ? -1 : this.editedItem.cutOfDate;
					this.showInputTextCutOf = false;
				}
				this.changeDepositDay(this.depositDay);
				this.changePaymentDay(this.paymentDay);
				// console.log(this.editedItem);
			});
		} else {
			this.editedItem = {
				// hotelId: null,
				cutOfDate: -1,
				paymentDay: -1,
				depositType: 1,
				amount: null,
				startDate: null,
				endDate: null,
				type: 0
			};
		}
		_resetErrorState(this.error);
		if (!this.editedItem.type) {
			this.editedItem.startDate = "";
			this.editedItem.endDate = "";
		}
	},
	mounted() {
		document
			.querySelector(".v-tab.v-tab--active")
			.classList.remove("v-tab--active");
		document
			.querySelector(".v-tab[tabIndex='1']")
			.classList.add("v-tab--active");
	},
	computed: {
		REGEX_NUMBER() {
			return REGEX_NUMBER;
		}
	},
	watch: {
		editedItem: {
			handler(value) {
				if (value.startDate > value.endDate) {
					this.editedItem.endDate = "";
				}
			},
			deep: true
		},
		error: {
			handler(value) {
				this.forfeitError = {
					value: value.amount.error,
					unit: null
				};
			},
			deep: true
		},
		forfeitError: {
			handler(value) {
				this.error.amount.error = value.value;
			},
			deep: true
		}
	},
	methods: {
		back() {
			this.$router.back();
		},
		async save() {
			let element = document.querySelector(".btn-save");
			element.disabled = true;
			let { isValid, error } = _validateFormI18n(this.editedItem, this.error);
			this.error = error;
			if (
			(parseFloat(this.editedItem.cutOfDate) > 0 && parseFloat(this.editedItem.cutOfDate) <
				parseFloat(this.editedItem.paymentDay) ) || (this.paymentDay === 3 && parseFloat(this.editedItem.paymentDay) <= 0)
			) {
				this.error.cutOfDate.error = true;
				this.error.paymentDay.error = true;
				this.$store.commit("alert/display", {
					message: this.$t("DEPOSIT_COMPARE_PAYMENT"),
					error: true,
					success: false
				});
				isValid = false;
			}
			if (!isValid) {
				element.disabled = false;
				return false;
			}
			if (this.editedItem.type) {
				if (!this.editedItem.startDate) {
					this.error.startDate.error = true;
				}
				if (!this.editedItem.endDate) {
					this.error.endDate.error = true;
				}
				if (this.error.startDate.error || this.error.endDate.error) {
					this.$store.commit("alert/display", {
						message: this.$t("MISSING_FIELD"),
						error: true,
						success: false
					});
					element.disabled = false;
					return false;
				}
			}
			let temp = {
				depositId: this.editedItem.id,
				amount: this.editedItem.amount,
				depositType: this.editedItem.depositType,
				cutOfDate: this.editedItem.cutOfDate,
				paymentDay: this.editedItem.paymentDay,
				startDate: this.editedItem.startDate,
				endDate: this.editedItem.endDate,
				type: this.editedItem.type
			};
			if (this.editedItem.id) {
				await service.update(temp).then(res => {
					_alert(res, this.$t(res.data));
					if (res.responseCode != 0) {
						element.disabled = false;
					}
				});
			} else {
				await service.insert(this.editedItem).then(res => {
					_alert(res, this.$t(res.data), false);
					let vm = this;
					setTimeout(function() {
						vm.$router.push({ name: "listOfPayments" });
					}, 1000);
					if (res.responseCode != 0) {
						element.disabled = false;
					}
				});
			}
		},
		changePaymentDay(event) {
			if (event === 3) {
				if (this.editedItem.paymentDay < 1) {
					this.editedItem.paymentDay = null;
				}
				this.showInputText = true;
			} else {
				this.showInputText = false;
				this.editedItem.paymentDay = event;
			}
		},
		changeDepositDay(event) {
			if (event === 3) {
				if (this.editedItem.cutOfDate < 1) {
					this.editedItem.cutOfDate = null;
				}
				this.showInputTextCutOf = true;
			} else {
				this.showInputTextCutOf = false;
				this.editedItem.cutOfDate = event;
			}
		},
	}
};
</script>
